import { AxiosPromise, AxiosRequestConfig } from "axios";
import { sdk } from "./coode-sdk-config";

type Api = any;

export class Connection {
    private api: Api;

    public constructor(api?: Api) {
        this.api = api ?? sdk.backend.request.api;
    }

    public get<T = any>(
        url: string,
        config?: AxiosRequestConfig
    ): AxiosPromise<T> {
        return this.api.get(url, config);
    }

    public post<T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): AxiosPromise<T> {
        return this.api.post(url, data, config);
    }

    public put<T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): AxiosPromise<T> {
        return this.api.put(url, data, config);
    }

    public delete(url: string, config?: AxiosRequestConfig): AxiosPromise {
        return this.api.delete(url, config);
    }
}
